import {Endpoint} from '@eryxcoop/appyx-comm';

export default class EditOrCreateCustomerOnboardingDeliverySiteOnboardingRequestEndpoint extends Endpoint {
    adaptValues({
                    taxpayerIdentificationNumber,
                    deliverySiteOnboardingRequest,
                }) {
        return {
            taxpayer_identification_number: taxpayerIdentificationNumber,
            delivery_site_onboarding_request_external_id: deliverySiteOnboardingRequest.id,
            name: deliverySiteOnboardingRequest.name,
            address: deliverySiteOnboardingRequest.address,
            city: deliverySiteOnboardingRequest.city,
            postal_code: deliverySiteOnboardingRequest.postalCode,
            jurisdiction: deliverySiteOnboardingRequest.jurisdiction,
            zone: deliverySiteOnboardingRequest.zone,
            preferred_delivery_time_range: deliverySiteOnboardingRequest.preferredDeliveryTimeRange,
            exceptional_frequency: deliverySiteOnboardingRequest.exceptionalFrequency,
        };
    }
}
